"use strict";

var _slicedToArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/createClass.js");

require("core-js/modules/esnext.promise.all-settled.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRedoclyRegistryURL = exports.RedoclyClient = void 0;

var fs_1 = require("fs");

var path_1 = require("path");

var os_1 = require("os");

var registry_api_1 = require("./registry-api");

var config_1 = require("../config/config");

var env_1 = require("../env");

var utils_1 = require("../utils");

var logger_1 = require("../logger");

var TOKEN_FILENAME = '.redocly-config.json';

var RedoclyClient = /*#__PURE__*/function () {
  function RedoclyClient(region) {
    _classCallCheck(this, RedoclyClient);

    this.accessTokens = {};
    this.region = this.loadRegion(region);
    this.loadTokens();
    this.domain = region ? config_1.DOMAINS[region] : env_1.env.REDOCLY_DOMAIN || config_1.DOMAINS[config_1.DEFAULT_REGION];
    env_1.env.REDOCLY_DOMAIN = this.domain; // isRedoclyRegistryURL depends on the value to be set

    this.registryApi = new registry_api_1.RegistryApi(this.accessTokens, this.region);
  }

  _createClass(RedoclyClient, [{
    key: "loadRegion",
    value: function loadRegion(region) {
      if (region && !config_1.DOMAINS[region]) {
        throw new Error("Invalid argument: region in config file.\nGiven: ".concat(logger_1.colorize.green(region), ", choices: \"us\", \"eu\"."));
      }

      if (env_1.env.REDOCLY_DOMAIN) {
        return config_1.AVAILABLE_REGIONS.find(function (region) {
          return config_1.DOMAINS[region] === env_1.env.REDOCLY_DOMAIN;
        }) || config_1.DEFAULT_REGION;
      }

      return region || config_1.DEFAULT_REGION;
    }
  }, {
    key: "getRegion",
    value: function getRegion() {
      return this.region;
    }
  }, {
    key: "hasTokens",
    value: function hasTokens() {
      return utils_1.isNotEmptyObject(this.accessTokens);
    } // <backward compatibility: old versions of portal>

  }, {
    key: "hasToken",
    value: function hasToken() {
      return !!this.accessTokens[this.region];
    }
  }, {
    key: "getAuthorizationHeader",
    value: function getAuthorizationHeader() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.accessTokens[this.region]);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    } // </backward compatibility: portal>

  }, {
    key: "setAccessTokens",
    value: function setAccessTokens(accessTokens) {
      this.accessTokens = accessTokens;
    }
  }, {
    key: "loadTokens",
    value: function loadTokens() {
      var credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);
      var credentials = this.readCredentialsFile(credentialsPath);

      if (utils_1.isNotEmptyObject(credentials)) {
        this.setAccessTokens(Object.assign(Object.assign({}, credentials), credentials.token && !credentials[this.region] && _defineProperty({}, this.region, credentials.token)));
      }

      if (env_1.env.REDOCLY_AUTHORIZATION) {
        this.setAccessTokens(Object.assign(Object.assign({}, this.accessTokens), _defineProperty({}, this.region, env_1.env.REDOCLY_AUTHORIZATION)));
      }
    }
  }, {
    key: "getAllTokens",
    value: function getAllTokens() {
      return Object.entries(this.accessTokens).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            region = _ref3[0];

        return config_1.AVAILABLE_REGIONS.includes(region);
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            region = _ref5[0],
            token = _ref5[1];

        return {
          region: region,
          token: token
        };
      });
    }
  }, {
    key: "getValidTokens",
    value: function getValidTokens() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var allTokens, verifiedTokens;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                allTokens = this.getAllTokens();
                _context2.next = 3;
                return Promise.allSettled(allTokens.map(function (_ref6) {
                  var token = _ref6.token,
                      region = _ref6.region;
                  return _this.verifyToken(token, region);
                }));

              case 3:
                verifiedTokens = _context2.sent;
                return _context2.abrupt("return", allTokens.filter(function (_, index) {
                  return verifiedTokens[index].status === 'fulfilled';
                }).map(function (_ref7) {
                  var token = _ref7.token,
                      region = _ref7.region;
                  return {
                    token: token,
                    region: region,
                    valid: true
                  };
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getTokens",
    value: function getTokens() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.hasTokens()) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 3;
                return this.getValidTokens();

              case 3:
                _context3.t0 = _context3.sent;
                _context3.next = 7;
                break;

              case 6:
                _context3.t0 = [];

              case 7:
                return _context3.abrupt("return", _context3.t0);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "isAuthorizedWithRedoclyByRegion",
    value: function isAuthorizedWithRedoclyByRegion() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.hasTokens()) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", false);

              case 2:
                accessToken = this.accessTokens[this.region];

                if (accessToken) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return", false);

              case 5:
                _context4.prev = 5;
                _context4.next = 8;
                return this.verifyToken(accessToken, this.region);

              case 8:
                return _context4.abrupt("return", true);

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](5);
                return _context4.abrupt("return", false);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));
    }
  }, {
    key: "isAuthorizedWithRedocly",
    value: function isAuthorizedWithRedocly() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = this.hasTokens();

                if (!_context5.t0) {
                  _context5.next = 7;
                  break;
                }

                _context5.t1 = utils_1;
                _context5.next = 5;
                return this.getValidTokens();

              case 5:
                _context5.t2 = _context5.sent;
                _context5.t0 = _context5.t1.isNotEmptyObject.call(_context5.t1, _context5.t2);

              case 7:
                return _context5.abrupt("return", _context5.t0);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "readCredentialsFile",
    value: function readCredentialsFile(credentialsPath) {
      return fs_1.existsSync(credentialsPath) ? JSON.parse(fs_1.readFileSync(credentialsPath, 'utf-8')) : {};
    }
  }, {
    key: "verifyToken",
    value: function verifyToken(accessToken, region) {
      var verbose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.registryApi.authStatus(accessToken, region, verbose));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "login",
    value: function login(accessToken) {
      var verbose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _Object$assign2;

        var credentialsPath, credentials;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);
                _context7.prev = 1;
                _context7.next = 4;
                return this.verifyToken(accessToken, this.region, verbose);

              case 4:
                _context7.next = 9;
                break;

              case 6:
                _context7.prev = 6;
                _context7.t0 = _context7["catch"](1);
                throw new Error('Authorization failed. Please check if you entered a valid API key.');

              case 9:
                credentials = Object.assign(Object.assign({}, this.readCredentialsFile(credentialsPath)), (_Object$assign2 = {}, _defineProperty(_Object$assign2, this.region, accessToken), _defineProperty(_Object$assign2, "token", accessToken), _Object$assign2));
                this.accessTokens = credentials;
                this.registryApi.setAccessTokens(credentials);
                fs_1.writeFileSync(credentialsPath, JSON.stringify(credentials, null, 2));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 6]]);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      var credentialsPath = path_1.resolve(os_1.homedir(), TOKEN_FILENAME);

      if (fs_1.existsSync(credentialsPath)) {
        fs_1.unlinkSync(credentialsPath);
      }
    }
  }]);

  return RedoclyClient;
}();

exports.RedoclyClient = RedoclyClient;

function isRedoclyRegistryURL(link) {
  var domain = env_1.env.REDOCLY_DOMAIN || config_1.DOMAINS[config_1.DEFAULT_REGION];
  var legacyDomain = domain === 'redocly.com' ? 'redoc.ly' : domain;

  if (!link.startsWith("https://api.".concat(domain, "/registry/")) && !link.startsWith("https://api.".concat(legacyDomain, "/registry/"))) {
    return false;
  }

  return true;
}

exports.isRedoclyRegistryURL = isRedoclyRegistryURL;